import { store } from "../../store";

export const useMockData = () => {
  const { env } = store.getState().boot.configuration;
  const isProdEnv = env === "prod";
  const urlParam = new URLSearchParams(window.location.search);
  const useMock = urlParam.get("useMock") === "true" && !isProdEnv;

  return useMock;
};
